<template>
  <div class="card mb-2">
    <div class="card-header d-flex justify-content-between" @click="toggleBodyVisibility()">
      <span v-if="regionData.bx_alias">
        區域別名：{{ regionData.bx_alias }}
      </span>
      <span v-else>
        區域名稱：{{ regionData.name }}
      </span>
      <div v-show="this.showRegionBody">
        <i class="fa-solid fa-angle-down"></i>
      </div>
      <div v-show="!this.showRegionBody">
        <i class="fa-solid fa-angle-up"></i>
      </div>
    </div>
    <div v-show="showRegionBody">
      <div class="card-body">
        <div class="regionUsers p-4">
          <div class="row">
            <div class="col-3">使用者名稱</div>
            <div class="col-4">電子郵件</div>
            <div class="col-3">建立時間</div>
            <div class="col-2"></div>
          </div>
          <div v-for="user, index in users" :key="index">
            <account-component v-show="!user.is_deleted" :user-data="user" :region-id="regionData.id"
              @update-user="updateUser"></account-component>
          </div>
          <div class="regionUsersFooter">
            <button class="btn btn-success btn-sm" data-toggle="modal"
              :data-target="`#addUserIntoRegion` + regionData.id">新增使用者</button>
            <div class="modal fade" :id="`addUserIntoRegion` + regionData.id" tabindex="-1" role="dialog">
              <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title">新增{{ regionData.bx_alias }}區域使用者</h5>
                  </div>
                  <div class="modal-body">
                    <div class="form-group row">
                      <label class="col-sm-5 col-form-label" for="user">使用者電子郵件：</label>
                      <div class="col-sm-7">
                        <input class="form-control" type="text" id="user" v-model="user_email"
                          placeholder="example@email.com">
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">取消</button>
                    <button type="button" class="btn btn-success" @click="addUserIntoRegion(regionData.id)"
                      data-dismiss="modal">
                      新增
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="regionMeters p-4">
          <div class="row">
            <div class="col-9">mac address</div>
            <div class="col-3"></div>
          </div>
          <div v-for="meter, index in regionData.meters" :key="index">
            <meter-component :meter-data="meter" @update-region="updateRegion"></meter-component>
          </div>
          <div class="regionUsersFooter">
            <button class="btn btn-success btn-sm" data-toggle="modal"
              :data-target="`#addMacIntoRegion` + regionData.id">新增裝置</button>

            <div class="modal fade" :id="`addMacIntoRegion` + regionData.id" tabindex="-1" role="dialog">
              <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title">新增區域裝置</h5>
                  </div>
                  <div class="modal-body">
                    <div class="form-group row">
                      <label class="col-sm-5 col-form-label" for="mac">MAC Address:</label>
                      <div class="col-sm-7">
                        <input type="text" class="form-control" id="mac" v-model="mac" placeholder="00:AA:BB:CC" required
                          v-mac-address>
                        <div v-if="macAddressError" class="text-danger">MAC Address 以冒號分隔，皆為英文大寫</div>
                      </div>
                    </div>
                    <edit-region-meter ref="editRegionMeter" @update-circuits="updateCircuits"></edit-region-meter>
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="closeModal(regionData.id)">取消</button>
                    <button type="button" class="btn btn-success" @click="addMacIntoRegion(regionData.id)">
                      新增
                    </button>
                  </div>
                </div>
              </div>
            </div>


          </div>
        </div>
      </div>
      <div class="card-footer d-flex justify-content-end">
        <button type="button" class="btn btn-success btn-sm" data-toggle="modal"
          :data-target="`#editRegionModal` + regionData.id">
          編輯
        </button>
        <edit-region :region-data="regionData" @update-region="updateRegion" @update-user="updateUser"></edit-region>
      </div>
    </div>
  </div>
</template>

<script>
import AccountComponent from './AccountComponent.vue';
import EditRegion from './EditRegion.vue';
import EditRegionMeter from './EditRegionMeter.vue';
import MeterComponent from './MeterComponent.vue';
import { axiosMixins } from '../mixins/axiosErrorMessage.js';

export default {
  mixins: [axiosMixins],
  data() {
    return {
      users: '',
      showRegionBody: true,
      user_email: '',
      mac: '',
      circuits: [],
      macAddressError: false, // 儲存驗證錯誤狀態
      is_dev: false
    }
  },
  mounted() {
    process.env.NODE_ENV !== "production" ? this.is_dev = true : this.is_dev = false;
    this.isMobile() ? this.showRegionBody = false : this.showRegionBody = true;
    this.updateUser();
  },
  methods: {
    listRegionUsers() {
      const region_id = this.$props.regionData.id;
      axios.get(base_url + "/api/regions/" + region_id)
        .then((response) => {
          this.users = response.data[0].users;
        })
        .catch((error) => this.axiosMessage(error));
    },
    isMobile() {
      return window.innerWidth < 768;
    },
    addMacIntoRegion(region_id) {
      console.log("==region-component== add meter", region_id)
      console.log("==region-component== add meter", !!this.circuits)
      if (this.circuits.length <= 0 || this.circuits[0].channels.length <= 0) {
        this.errorAlert('請設定線路及迴路');
      } else if (!this.mac) {
        this.errorAlert('MAC Address 為必填');
      } else {
        this.circuits = this.circuits.filter(function (circuit) {
          return circuit.channels.length !== 0;
        })
        const add_mac_into_region = {
          bx_mac: this.mac,
          region_id: region_id,
          mac_alias: '',
          circuits: this.circuits
        };
        axios.post(base_url + '/api/bx', add_mac_into_region)
          .then(response => {
            if (response.data.message === 'This mac has been used') {
              this.errorAlert('這個 mac 已被加入其他區域中。');
            } else if (response.data.message === 'This mac address does not exist') {
              this.errorAlert('這個 mac address 不存在。');
            }
            this.$emit('update-region')
          })
          .catch(error => { console.error('Error adding mac into region:', error.toJSON()); })
        this.closeModal(region_id);
      }
    },
    closeModal(region_id) {
      this.mac = '';
      this.circuits = '';
      this.$refs.editRegionMeter.circuits = [];
      this.$refs.editRegionMeter.selectedLoops = [];
      this.$refs.editRegionMeter.usedLoops = [];
      this.$refs.editRegionMeter.circuit_alias = [];
      const modal = this.$el.querySelector('#addMacIntoRegion' + region_id);
      modal.classList.remove('show');
      modal.style.display = 'none';
      document.body.classList.remove('modal-open');
      document.querySelector('.modal-backdrop').remove();
    },
    addUserIntoRegion(region_id) {
      const add_user_into_region = {
        account: this.user_email,
        role_id: 2,
        region_id: region_id,
      };
      axios.post(base_url + '/api/share/region', add_user_into_region)
        .then(response => {
          this.user_email = '';
          this.updateUser();
        })
        .catch(error => {
          if (error.response) {
            this.errorAlert(`Adding user fail: ${error.response.data.message}`);
          } else if (error.request) {
            this.errorAlert(`Adding user fail: ${error.request}`);
          } else {
            this.errorAlert(`Error ${error.message}`);
          }
        })
    },
    toggleBodyVisibility() {
      this.showRegionBody = !this.showRegionBody
    },
    updateUser() {
      this.listRegionUsers();
    },
    updateRegion() {
      this.$emit('update-region');
    },
    updateCircuits(circuits) {
      this.circuits = circuits;
    },
    errorAlert(message) {
      if (this.is_dev) {
        console.error(message);
      } else {
        alert(message);
      }
    }
  },
  props: ['regionData'],
  components: { EditRegion, AccountComponent, MeterComponent, EditRegionMeter },
  directives: {
    'mac-address': {
      bind(el, binding, vnode) {
        el.addEventListener('input', () => {
          const macRegex = /^([0-9A-F]{2}:){5}[0-9A-F]{2}$/;
          const isValid = macRegex.test(el.value);
          vnode.context.macAddressError = !isValid;
        });
      }
    }
  }
}
</script>

<style scoped>
.text-danger {
  font-size: .8rem;
}
</style>
